import { Accordion } from 'radix-ui';
import { MdKeyboardArrowDown } from 'react-icons/md';
import styled from 'styled-components';

export const ArrowDown = styled(MdKeyboardArrowDown)`
  height: 1rem;
  width: 1rem;
  transition: transform 300ms;
`;

export const AccordionHeader = styled(Accordion.Header)`
  &[data-state='open'] {
    & ${ArrowDown} {
      transform: rotate(180deg);
    }
  }
`;

export const AccordionTrigger = styled(Accordion.Trigger)``;
